import { ShimmerBlock, ShimmerLines, ShimmerRelGroup } from './Shimmer'

export function EntityDetailSkeleton() {
  return (
    <article className="ed-page">
      <section className="ed-hero">
        <div className="ed-hero-bg ed-hero-bg--grad skel" />
        <div className="ed-hero-overlay" />
        <div className="ed-hero-content">
          <div className="ed-hero-inner">
            <ShimmerBlock width={90} height={14} style={{ marginBottom: 16 }} />
            <ShimmerBlock width="55%" height={44} style={{ marginBottom: 16 }} />
            <ShimmerBlock width="40%" height={18} style={{ marginBottom: 28 }} />
            <div style={{ display: 'flex', gap: 28, marginBottom: 28 }}>
              {[0, 1, 2].map(i => (
                <div key={i}>
                  <ShimmerBlock width={60} height={10} style={{ marginBottom: 6 }} />
                  <ShimmerBlock width={80} height={15} />
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', gap: 12 }}>
              <ShimmerBlock width={140} height={44} />
              <ShimmerBlock width={110} height={44} />
            </div>
          </div>
        </div>
      </section>

      <section className="ed-section">
        <div className="ed-section-inner">
          <ShimmerBlock width={110} height={12} style={{ marginBottom: 18 }} />
          <ShimmerLines count={4} />
        </div>
      </section>

      <section className="ed-section">
        <div className="ed-section-inner">
          <ShimmerBlock width={90} height={12} style={{ marginBottom: 18 }} />
          <ShimmerRelGroup />
        </div>
      </section>
    </article>
  )
}
